import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fileUrl } from "@/lib/api";
import Placeholder from "@/components/Placeholder";

export default function ProjectCard({ project, index = 0 }) {
  const videoRef = useRef(null);

  const onEnter = () => videoRef.current?.play().catch(() => {});
  const onLeave = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  return (
    <Link
      to={`/work/${project.slug}`}
      data-testid={`project-card-${project.slug}`}
      className="group block"
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      <div className="relative overflow-hidden border border-border bg-muted aspect-[4/3]">
        {project.cover_image ? (
          <img
            src={fileUrl(project.cover_image)}
            alt={project.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        ) : (
          <div className="h-full w-full transition-transform duration-700 ease-out group-hover:scale-105">
            <Placeholder label={project.title} className="h-full w-full" />
          </div>
        )}
        {project.hover_video && (
          <video
            ref={videoRef}
            src={fileUrl(project.hover_video)}
            muted
            loop
            playsInline
            preload="metadata"
            aria-hidden="true"
            className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100"
          />
        )}
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-3 text-xs uppercase tracking-[0.2em] font-mono">
            <span className="text-accent">{project.category}</span>
            {project.year && <span className="text-muted-foreground">{project.year}</span>}
          </div>
          <h3 className="mt-2 font-serif text-2xl tracking-tight leading-snug">
            <span className="text-muted-foreground/60 font-mono text-xs align-super mr-2">
              {String(index + 1).padStart(2, "0")}
            </span>
            {project.title}
          </h3>
          {project.summary && (
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed max-w-md">
              {project.summary}
            </p>
          )}
        </div>
        <ArrowUpRight
          size={20}
          className="shrink-0 mt-1 text-muted-foreground transition-all duration-500 group-hover:text-accent group-hover:translate-x-1 group-hover:-translate-y-1"
        />
      </div>
    </Link>
  );
}
